export default {
  apiPath: `${window.location.origin}/api`,
  serverPath: window.location.origin,
  apiVersion: '/v2'
}
